
import { useEffect, useState } from "react"

import { Card, CardMedia, Box, CardContent, Typography, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, CircularProgress, Grow, CardActionArea, CardHeader } from "@mui/material"

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import UndoOutlinedIcon from "@mui/icons-material/UndoOutlined";
import FileOpenOutlinedIcon from "@mui/icons-material/FileOpenOutlined";
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

import { ObtenerAutoridades, ObtenerDocumentoListaAcuerdo, ObtenerListaAcuerdos, ObtenerMaterias } from "../connections/comun/ListaAcuerdosConnection";

import { MateriaProps } from "../interfaces/comun/MateriaInterface";
import { AutoridadProps } from "../interfaces/comun/AutoridadInterface";
import { ListaAcuerdosProps } from "../interfaces/comun/ListaAcuerdosInterface";

interface Props {
    handleSound:  () => void;
    onPause:      () => void;
    onReset:      () => void;
}

export const CardListaAcuerdos = ( { handleSound, onPause, onReset }: Props ) => {

    const [titulo, setTitulo] = useState('');

    const [openDialog, setOpenDialog] = useState(false);

    const [loadingMaterias, setloadingMaterias] = useState(false);
    const [descripcionMateria, setDescripcionMateria] = useState( '' );
    const [materias, setMaterias] = useState<MateriaProps[]>( [] );

    const [loadingAutoridades, setloadingAutoridades] = useState(false);
    const [aplicarAutoridades, setAplicarAutoridades] = useState(false);
    const [autoridades, setAutoridades] = useState<AutoridadProps[]>( [] );

    const [loadingListaAcuerdos, setloadingListaAcuerdos] = useState(false);
    const [aplicarListaAcuerdos, setAplicarListaAcuerdos] = useState(false);
    const [listaAcuerdos, setListaAcuerdos] = useState<ListaAcuerdosProps[]>( [] );

    const [fullScreen, setFullScreen] = useState( true );
    const [openDocumento, setOpenDocumento] = useState( false );
    const [documento, setDocumento] = useState( '' );

    const handleClose = () => {
        handleSound();
        setOpenDialog( false );
        onReset();
    }

    const handleBackMaterias = () => {

        handleSound();

        setTitulo( 'Materias' );
        setAplicarAutoridades( false );
        setAutoridades([]);

    }

    const handleBackAutoridades = () => {

        handleSound();

        setTitulo( `Autoridades en materia ${ descripcionMateria }` );
        setAplicarListaAcuerdos( false );
        setListaAcuerdos([]);

    }
    
    const handleObtenerAutoridades = async ( clave: string, materia: string ) => {

        handleSound();
        setDescripcionMateria( materia );

        setTitulo( `Autoridades en materia ${ materia }` );
        setloadingAutoridades( true );
        setAplicarAutoridades( true );
        setAutoridades([]);

        await ObtenerAutoridades( clave ).then( resp => {

            setTimeout(() => {

                setAutoridades( resp.data );
                setloadingAutoridades( false );

            }, 700);
        });

    }

    const handleObtenerListaAcuerdos = async ( clave: string, descripcion: string ) => {

        handleSound();

        setTitulo( descripcion );
        setloadingListaAcuerdos( true );
        setAplicarListaAcuerdos( true );
        setListaAcuerdos([]);

        await ObtenerListaAcuerdos( clave ).then( resp => {

            setTimeout(() => {

                setListaAcuerdos( resp.data.map( (e) => { e.loading = false; return e; }) );
                setloadingListaAcuerdos( false );

            }, 700);
        });

    }

    const handleObtenerDocumento = async ( id: number ) => {

        handleSound();
        setDocumento('');

        const newArray = listaAcuerdos.map( (e) => { 
            if( e.id === id ){
                e.loading = true; 
            }
            return e; 
        });
        setListaAcuerdos( newArray );

        await ObtenerDocumentoListaAcuerdo( id ).then( blob => {           

            if( blob ){

                setTimeout(() => {
                  
                    const url = URL.createObjectURL( blob );
                    setDocumento( url );           
                    setOpenDocumento( true );     
                    
                    const newArray = listaAcuerdos.map( (e) => { 
                        if( e.id === id ){
                            e.loading = false; 
                        }
                        return e; 
                    });
                    setListaAcuerdos( newArray );

                }, 700);    

            }

        });

    }    

    useEffect(() => {
      
        async function obtener() {
            
            setTitulo( 'Materias' );

            setloadingMaterias( true );

            setloadingAutoridades( false );
            setAplicarAutoridades( false );
            setAutoridades([]);

            setloadingListaAcuerdos( false );
            setAplicarListaAcuerdos( false );
            setListaAcuerdos([]);
            setFullScreen( true );

            setDocumento('');

            await ObtenerMaterias().then( resp => {

                setTimeout(() => {
                    
                    setMaterias( resp.data );
                    setloadingMaterias( false );

                }, 700);
            });

        }
      
        obtener();        

    }, [ openDialog ])    

    return (
        <>
            
            <Card>   
                
                <CardActionArea sx={{ display: 'flex' }} onClick={ () => { handleSound(); setOpenDialog( true ); onPause(); } }>

                    <CardMedia
                        component="img"
                        sx={{ width: 155, height: '100%' }}
                        image={ process.env.PUBLIC_URL + "/assets/lista-acuerdos.png" }
                        alt={"image-lista-acuerdos"}
                    />        

                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>  

                        <CardContent sx={{ flex: '1 0 auto' }}>

                            <Typography gutterBottom fontSize={22} fontWeight={'500'} variant="h6" component="div">
                                Consulta la lista de acuerdos aquí
                            </Typography>

                            <Typography gutterBottom fontSize={14} variant="caption" component="div">
                                Son las actuaciones que realiza diariamente el Poder Judicial del Estado de Coahuila de Zaragoza y que por ley de acuerdo al Código Procesal Civil deben de ser publicadas; en donde se incluyen autos, acuerdos, sentencias, exhortos y audiencias.
                            </Typography>

                        </CardContent>   

                    </Box>       
                
                </CardActionArea>    

            </Card>
            
            <Dialog 
                fullWidth
                maxWidth='lg'
                open={ openDialog } 
                onClose={ () => { } } 
            >

                <DialogTitle sx={{ bgcolor: '#f5f5f5' }} >

                    <Grid container spacing={3}>

                        <Grid size={8}> <Typography variant="h6">{ titulo }</Typography> </Grid>
                      
                        <Grid size={4} textAlign={'end'}>
                            {
                                ( aplicarAutoridades && !aplicarListaAcuerdos )
                                &&
                                    <Button size="small" color="secondary" startIcon={ <UndoOutlinedIcon /> } onClick={ handleBackMaterias }>Regresar a materias</Button>
                            }
                            {
                                aplicarListaAcuerdos
                                &&
                                    <Button size="small" color="secondary" startIcon={ <UndoOutlinedIcon /> } onClick={ handleBackAutoridades }>Regresar a autoridades</Button>
                            }
                        </Grid>

                    </Grid>       

                </DialogTitle>

                <DialogContent sx={{ height: 500, bgcolor: '#f5f5f5' }}>

                    {
                        ( !loadingMaterias && materias.length !== 0 && !aplicarAutoridades )
                        ?
                            materias.map( ( { clave, nombre, descripcion }, index ) => (

                                <Grow
                                    key={index}
                                    in={true}
                                    style={{ transformOrigin: '0 0 0' }}
                                    {...(true ? { timeout: 1000 } : {})}
                                >

                                    <Card
                                        onClick={ () => handleObtenerAutoridades( clave, nombre ) }   
                                        sx={{ my: 2, cursor: 'pointer' }}                                         
                                    >
                                        <CardHeader  
                                            sx={{ px: 3 }}
                                            title={ <Typography variant="h6"> { nombre }</Typography> }
                                            action={ <IconButton> <ArrowForwardIosIcon /> </IconButton> }
                                        />

                                        {
                                            descripcion
                                            &&
                                                <CardContent sx={{ px: 3, py: 0 }}>
                                                    <Typography color="secondary" variant="subtitle1">{ descripcion }</Typography>                                           
                                                </CardContent>
                                        }                                            

                                    </Card>

                                </Grow>
                            ))
                        :
                            loadingMaterias
                            ?
                                <Box height={450} textAlign={'center'} alignContent={'center'}>
                                    <CircularProgress size={45} />
                                </Box>
                            :
                                ( !loadingMaterias && materias.length === 0 )
                                &&
                                    <Box height={450} textAlign={'center'} alignContent={'center'}>
                                        <Typography variant="body2">No se encontraron materias</Typography>
                                    </Box>
                    }

                    {
                        ( !loadingAutoridades && autoridades.length !== 0 && !aplicarListaAcuerdos )
                        ?
                            autoridades.map( ( { clave, descripcion }, index ) => (
                                <Grow
                                    key={index}
                                    in={true}
                                    style={{ transformOrigin: '0 0 0' }}
                                    {...(true ? { timeout: 1000 } : {})}
                                >
                                    
                                    <Card
                                        onClick={ () => handleObtenerListaAcuerdos( clave, descripcion ) }   
                                        sx={{ my: 2, cursor: 'pointer' }}                                         
                                    >
                                        <CardHeader  
                                            sx={{ px: 3 }}
                                            title={ <Typography variant="h6"> { descripcion }</Typography> }
                                            action={ <IconButton> <ArrowForwardIosIcon /> </IconButton> }
                                        />                                         

                                    </Card>
                                    
                                </Grow>
                            ))
                        :
                            loadingAutoridades
                            ?
                                <Box height={450} textAlign={'center'} alignContent={'center'}>
                                    <CircularProgress size={45} />
                                </Box>
                            :
                                ( !loadingAutoridades && autoridades.length === 0 && aplicarAutoridades )
                                &&
                                    <Box height={450} textAlign={'center'} alignContent={'center'}>
                                        <Typography variant="body2">No se encontraron autoridades</Typography>
                                    </Box>
                    }

                    {
                        ( !loadingListaAcuerdos && listaAcuerdos.length !== 0 )
                        ?
                            listaAcuerdos.map( ( { id, descripcion, fecha, loading }, index ) => (
                                <Grow
                                    key={index}
                                    in={true}
                                    style={{ transformOrigin: '0 0 0' }}
                                    {...(true ? { timeout: 1000 } : {})}
                                >
                                    <Card
                                        onClick={ loading ? () => {} : () => handleObtenerDocumento( id ) }   
                                        sx={{ my: 2, cursor: loading ? 'default' : 'pointer' }}                 
                                    >
                                        <CardHeader  
                                            sx={{ px: 3 }}
                                            title={ <Typography color={ loading ? 'textDisabled' : 'primary' } variant="h6"> { descripcion }</Typography> }
                                            action={ <IconButton loading={ loading ?? false }> <FileOpenOutlinedIcon /> </IconButton> }
                                        />           
                                        
                                        {
                                            fecha
                                            &&
                                                <CardContent sx={{ px: 3, py: 0 }}>
                                                    <Typography color={ loading ? 'textDisabled' : 'secondary' } variant="subtitle1">{ fecha.toString() }</Typography>                                           
                                                </CardContent>
                                        }                                     

                                    </Card>

                                </Grow>
                            ))
                        :
                            loadingListaAcuerdos
                            ?
                                <Box height={450} textAlign={'center'} alignContent={'center'}>
                                    <CircularProgress size={45} />
                                </Box>
                            :
                                ( !loadingListaAcuerdos && listaAcuerdos.length === 0 && aplicarListaAcuerdos )
                                &&
                                    <Box height={450} textAlign={'center'} alignContent={'center'}>
                                        <Typography variant="body2">No se encontraron listas de acuerdos</Typography>
                                    </Box>
                    }

                </DialogContent>

                <DialogActions sx={{ bgcolor: '#f5f5f5' }}>
                    <Button color='secondary' onClick={ handleClose }> Cerrar </Button>
                </DialogActions>

            </Dialog>

            <Dialog 
                maxWidth="md"
                fullWidth={ true } 
                open={ openDocumento } 
                fullScreen={ fullScreen } 
                onClose={ () => {} } 
            >       

                <DialogTitle sx={{ backgroundColor: '#3c3c3c', p: 0, textAlign: 'end' }}>
                
                    <IconButton size='small' sx={{ color: 'white' }} onClick={ () => { handleSound(); setFullScreen( (prev) => !prev ); } }>
                        { fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon /> } 
                    </IconButton>

                    <IconButton size='small' sx={{ color: 'white' }} onClick={ () => { handleSound(); setOpenDocumento( false ); } }>
                        <CloseIcon />
                    </IconButton>
                
                </DialogTitle>        
              
               <DialogContent sx={{ p: 0 }}>
                  
                   <Grid container spacing={3} height={'100%'} >                                                
                   
                       <Grid size={{ md: 12, xs: 12}} sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
 
                            {
                                documento
                                ?
                                   <iframe title='acuse' src={ documento } height={ fullScreen ? "100%" : '600px' } width="100%" style={{ border: 'none' }}></iframe>
                                :
                                    <Box height={600} sx={{ alignContent: 'center', justifyContent: 'center' }}>
                                        <Typography variant='subtitle2' sx={{ fontSize: 18, fontWeight: 'bold', mt: 10, mb: 10 }}>
                                            No se encontró el documento
                                        </Typography>     
                                    </Box>                     
                            }

                       </Grid>
                      
                   </Grid>
                  
               </DialogContent> 

                <DialogActions sx={{}}>
                    <Button color='secondary' onClick={ () => { handleSound(); setOpenDocumento( false ); } }> Cerrar </Button>
                </DialogActions>

            </Dialog>  
        
        </>
    )
}
